


const baseGeneralUrl = "General"
  const endpoints = {
   getCurrencies:`${baseGeneralUrl}/GetCurrencies`,
   
  
  };
  
  export default endpoints;
  



